(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('oggetto-consenso', {
            parent: 'entity',
            url: '/oggetto-consenso',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.oggettoConsenso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consensos.html',
                    controller: 'OggettoConsensoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('oggettoConsenso');
                    $translatePartialLoader.addPart('tipoOggettoConsenso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('oggetto-consenso-detail', {
            parent: 'oggetto-consenso',
            url: '/oggetto-consenso/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.oggettoConsenso.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-detail.html',
                    controller: 'OggettoConsensoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('oggettoConsenso');
                    $translatePartialLoader.addPart('tipoOggettoConsenso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OggettoConsenso', function($stateParams, OggettoConsenso) {
                    return OggettoConsenso.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'oggetto-consenso',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('oggetto-consenso-detail.edit', {
            parent: 'oggetto-consenso-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-dialog.html',
                    controller: 'OggettoConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OggettoConsenso', function(OggettoConsenso) {
                            return OggettoConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('oggetto-consenso.new', {
            parent: 'oggetto-consenso',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-dialog.html',
                    controller: 'OggettoConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipo: null,
                                codice: null,
                                info: null,
                                contenuto: null,
                                contenutoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('oggetto-consenso', null, { reload: 'oggetto-consenso' });
                }, function() {
                    $state.go('oggetto-consenso');
                });
            }]
        })
        .state('oggetto-consenso.edit', {
            parent: 'oggetto-consenso',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-dialog.html',
                    controller: 'OggettoConsensoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OggettoConsenso', function(OggettoConsenso) {
                            return OggettoConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('oggetto-consenso', null, { reload: 'oggetto-consenso' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('oggetto-consenso.delete', {
            parent: 'oggetto-consenso',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/oggetto-consenso/oggetto-consenso-delete-dialog.html',
                    controller: 'OggettoConsensoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OggettoConsenso', function(OggettoConsenso) {
                            return OggettoConsenso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('oggetto-consenso', null, { reload: 'oggetto-consenso' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
